export default function Garantia() {
  return (
    <section className="py-12 sm:py-20 bg-white overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="bg-gradient-to-br from-teal-50 to-white border-2 border-teal-200 rounded-3xl p-6 sm:p-10 text-center">
          {/* Ícone de selo */}
          <div className="w-24 h-24 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-6">
            <i className="ri-shield-check-fill text-teal-600 text-5xl"></i>
          </div>

          {/* Título */}
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            Garantia de 07 dias
          </h2>

          {/* Texto */}
          <div className="space-y-4 text-gray-700 text-base leading-relaxed max-w-2xl mx-auto">
            <p>
              Você tem <strong className="text-teal-600">07 dias completos</strong> para acessar todo o conteúdo, aplicar as estratégias e avaliar os resultados.
            </p>
            <p>
              Se por qualquer motivo você não ficar satisfeito, basta enviar um e-mail e devolvemos 100% do seu investimento. Sem perguntas, sem burocracia.
            </p>
            <p className="font-semibold text-gray-900 text-lg pt-4">
              O risco é todo nosso. Você só tem a ganhar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}